export const getRandomID = (length = 8) => {
    const array = new Uint8Array(length)
    crypto.getRandomValues(array)
    return Array.from(array, (byte) => byte.toString(16)).join("")
}
